module.exports = __webpack_public_path__ + "img/DSCF0334.2cfd73cc.2cfd73cc.jpg";